/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'all-alerts-module';
const componentName = 'all-alerts-list-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const timestampLabel = `${prefix}.timestamp`;
export const resourceNameLabel = `${prefix}.resourceName`;
export const levelLabel = `${prefix}.level`;
export const showDetailsLabel = `${prefix}.showDetails`;
export const resourceTypeLabel = `${prefix}.resourceType`;
export const eventCodeLabel = `${prefix}.eventCode`;
export const userLabel = `${prefix}.user`;
export const relatedEventsLabel = `${prefix}.relatedEventsLabel`;
export const relatedAlertConfigLabel = `${prefix}.relatedConfigAlerts`;
export const alertConfigLabel = `${prefix}.alertConfigLabel`;
export const editAlertConfigLabel = `${prefix}.editAlertConfigLabel`;
export const actionScriptOutputLabel = `${prefix}.actionScriptOutputLabel`;

export const ENGLISH = {
    [headerLabel]: 'All Alerts',
    [timestampLabel]: 'Timestamp',
    [resourceNameLabel]: 'Resource Name',
    [levelLabel]: 'Level',
    [showDetailsLabel]: 'Show Details',
    [resourceTypeLabel]: 'Resource Type',
    [eventCodeLabel]: 'Event Code',
    [userLabel]: 'User',
    [relatedEventsLabel]: 'Related Events ({0})',
    [relatedAlertConfigLabel]: 'Related Alert Config',
    [alertConfigLabel]: 'Alert Config Name',
    [editAlertConfigLabel]: 'Edit Alert Config',
    [actionScriptOutputLabel]: 'Action Script Output',
};
